<template>
  <div class="nppv-video-guide">
    <main v-if="currentPage === 'home'" class="guide-content guide-content-home">
      <button
        v-for="series in seriesList"
        :key="series.key"
        class="guide-card guide-card-home"
        type="button"
        @click="openSeries(series.key)"
      >
        <img class="guide-icon" src="@/assets/img/nppv-video-guide/nppv_video_icon.png" alt="" aria-hidden="true" />
        <span class="guide-card-title">{{ series.title }}</span>
        <img class="guide-arrow" src="@/assets/img/arrow-right.png" alt="" aria-hidden="true"></img>
      </button>
    </main>

    <main v-else-if="currentPage === 'list'" class="guide-content guide-content-list">
      <button
        v-for="video in currentVideos"
        :key="video.key"
        class="guide-card guide-card-video"
        type="button"
        @click="openVideo(video.key)"
      >
        <img class="guide-poster" :src="video.poster" alt="" aria-hidden="true" />
        <span class="guide-card-info">
          <span class="guide-card-title">{{ video.title }}</span>
          <span class="guide-card-duration">时长：{{ video.duration }}</span>
        </span>
        <img class="guide-arrow" src="@/assets/img/arrow-right.png" alt="" aria-hidden="true"></img>
      </button>
    </main>

    <main v-else-if="currentPage === 'play' && currentVideo" class="guide-content guide-content-play">
      <video
        class="guide-video"
        :src="currentVideo.url"
        :poster="currentVideo.poster"
        controls
        playsinline
        webkit-playsinline
        preload="metadata"
      ></video>
    </main>
  </div>
</template>

<script>
const VIDEO_BASE_URL = 'https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/video/nppv/'

const videoMap = {
  series7: {
    key: 'series7',
    title: '7系设备操作视频',
    url: `${VIDEO_BASE_URL}7系设备操作视频.mp4`,
    poster: require('@img/nppv-video-guide/series-7.png'),
    duration: '6分钟'
  },
  series8: {
    key: 'series8',
    title: '8系设备操作视频',
    url: `${VIDEO_BASE_URL}8系设备操作视频.mp4`,
    poster: require('@img/nppv-video-guide/series-8.png'),
    duration: '5分钟'
  },
  mask: {
    key: 'mask',
    title: '鼻罩佩戴说明',
    url: `${VIDEO_BASE_URL}鼻罩佩戴说明.mp4`,
    poster: require('@img/nppv-video-guide/mask.webp'),
    duration: '1分钟'
  },
  ring: {
    key: 'ring',
    title: '血氧指环使用指导',
    url: `${VIDEO_BASE_URL}血氧指环使用指导.mp4`,
    poster: require('@img/nppv-video-guide/ring.webp'),
    duration: '2分钟'
  }
}

const seriesConfig = {
  7: [videoMap.series7, videoMap.mask, videoMap.ring],
  8: [videoMap.series8, videoMap.mask, videoMap.ring]
}

export default {
  name: 'NppvVideoGuide',
  data () {
    return {
      seriesList: [
        {
          key: '7',
          title: '7系设备操作视频'
        },
        {
          key: '8',
          title: '8系设备操作视频'
        }
      ]
    }
  },
  computed: {
    currentPage () {
      const routeName = this.$route.name
      if (routeName === 'NppvVideoGuideList') return 'list'
      if (routeName === 'NppvVideoGuidePlay') return 'play'
      return 'home'
    },
    currentSeries () {
      const series = this.$route.query.series
      return seriesConfig[series] ? series : ''
    },
    currentVideos () {
      return seriesConfig[this.currentSeries] || []
    },
    currentVideo () {
      return videoMap[this.$route.query.video] || null
    },
    pageTitle () {
      if (this.currentPage === 'list') return '呼吸机使用指导'
      if (this.currentPage === 'play' && this.currentVideo) return this.currentVideo.title
      return 'NPPV相关视频指导'
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler () {
        this.ensureValidRoute()
        document.title = this.pageTitle
      }
    }
  },
  methods: {
    ensureValidRoute () {
      if (this.currentPage === 'list' && !this.currentSeries) {
        this.replaceHome()
        return
      }

      if (this.currentPage === 'play' && (!this.currentVideo || !this.currentSeries)) {
        this.replaceHome()
      }
    },
    replaceHome () {
      if (this.$route.name !== 'NppvVideoGuideHome') {
        this.$router.replace({ name: 'NppvVideoGuideHome' })
      }
    },
    openSeries (series) {
      this.$router.push({
        name: 'NppvVideoGuideList',
        query: {
          series
        }
      })
    },
    openVideo (video) {
      this.$router.push({
        name: 'NppvVideoGuidePlay',
        query: {
          series: this.currentSeries,
          video
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nppv-video-guide {
  min-height: 100%;
  background-color: #f6f6f6;
  color: #4a4a4a;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Arial, sans-serif;
}

.guide-content {
  box-sizing: border-box;
  width: 100%;
}

.guide-content-home {
  padding: 19px 20px 0;
}

.guide-content-list {
  padding: 34px 20px 0;
}

.guide-content-play {
  padding: 20px 16px 0;
}

.guide-card {
  box-sizing: border-box;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
}

.guide-card + .guide-card {
  margin-top: 20px;
}

.guide-card-home {
  display: flex;
  align-items: center;
  height: 70px;
  padding: 0 15px;
}

.guide-card-video {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 97px;
  padding: 13px 19px 12px 15px;
}

.guide-icon {
  position: relative;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 50%;
}


.guide-card-title {
  display: block;
  overflow: hidden;
  color: #555555;
  font-size: 15px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.guide-card-home .guide-card-title {
  margin-left: 30px;
  flex: 1;
}

.guide-arrow {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: auto;
  flex: 0 0 24px;
}

.guide-poster {
  width: 115px;
  height: 72px;
  flex: 0 0 115px;
  border-radius: 10px;
  object-fit: cover;
}

.guide-card-info {
  min-width: 0;
  margin-left: 13px;
  flex: 1;
}

.guide-card-duration {
  display: block;
  margin-top: 9px;
  color: #858585;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
}

.guide-video {
  display: block;
  width: 100%;
  max-height: calc(100vh - 105px);
  border-radius: 8px;
  background-color: #000000;
}
</style>
